import { LeadDashboard } from '~/models/LeadDashboard'
import { BaseRepository } from '~/passporter-services/baseRepository'
import { ApiLeadDashboard } from './apiTypes'
import { LeadDashboardApiMapper } from './apiMapper'

export class LeadDashboardRepository extends BaseRepository {
	private static resource = 'business'

	static async getDashboard(leadId: string): Promise<LeadDashboard> {
		const response: ApiLeadDashboard | undefined = await this.get(
			`${this.resource}/lead/${leadId}/dashboard/`
		)
		return LeadDashboardApiMapper.toLeadDashboard(response!)
	}
}
